'use client';

import type { CardBodyProps } from './CardBody.types';

export const CardBody = (props: CardBodyProps) => <div {...props} />;
